export function PersonaGeneratingPage() {
	return (
		<div className='absolute inset-0 flex flex-col items-center justify-center gap-2.5 text-center'>
			<img src='/assets/persona/puzzle-pieces.svg' alt='' className='size-40 animate-pulse' />
			<div className='max-w-md flex flex-col items-center gap-1.5'>
				<h2 className='text-sm font-semibold'>Setting Up Persona...</h2>
				<p className='text-xs text-muted-foreground'>
					Establishing Persona by reviewing previous tickets to identify trends, then create rules that align with
					your brand's voice or your agents' style.
				</p>
			</div>
		</div>
	);
}
